import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { GetCaseTypesWithPagingQuery } from './get-case-types-with-paging.query';
import { GetCaseTypesWithPagingResult } from './get-case-types-with-paging.result';
import { CaseTypeState } from '../../states';

@Injectable({ providedIn: 'root' })
export class GetCaseTypesWithPagingUseCase {
  private readonly _repository = inject(CaseTypeRepository);
  private readonly _state = inject(CaseTypeState);

  public execute(query: GetCaseTypesWithPagingQuery): Observable<GetCaseTypesWithPagingResult> {
    return this._repository.getCaseTypesWithPaging(query).pipe(
      map((result) => {
        this._state.setCaseTypes(result.data);
        this._state.setCaseTypesCount(result.totalElements);
        return {
          data: this._state.caseTypes(),
          totalElements: result.totalElements,
        }
      }),
    );
  }
}
